<div class="row">
    <div class="col-12">
        <div class="content-header">Discussion Form</div>
    </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
    <div class="row">
        <div class="col-12">
            <div class="card">

                <div class="card-content">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md">
                                <form [formGroup]="discussionForm">
                                    <fieldset class="form-group">
                                        <label>Question<span class="required_field">*</span></label>
                                        <input type="text" class="form-control" formControlName="question" id="question"
                                        [(ngModel)]="discussion_model.question" placeholder="Enter question" #question required>
                                        <div *ngIf="!rf.question.valid && (rf.question.dirty || rf.question.touched)"
                                            class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> Question is required!
                                        </div>
                                    </fieldset>
                                    <!-- <fieldset class="form-group">
                                        <label for="path">Email<span class="required_field">*</span></label>
                                        <input type="text" class="form-control" formControlName="email" id="email"
                                        [(ngModel)]="discussion_model.email" placeholder="Enter email" #email required>
                                        <div *ngIf="!rf.email.valid && (rf.email.dirty || rf.email.touched)"
                                            class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> Email is required!
                                        </div>
                                    </fieldset>
                                    <fieldset class="form-group">
                                        <label for="title">Phone</label>
                                        <input type="text" class="form-control" formControlName="phone" id="phone"
                                        [(ngModel)]="discussion_model.phone" placeholder="e.g. 1234-567-890" mask="0000-000-000"
                                        minlength="10" #phone required>
                                        <div *ngIf="!rf.phone.valid && (rf.phone.dirty || rf.phone.touched)"
                                            class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> Phone is required!
                                        </div>
                                    </fieldset>
                                    <fieldset class="form-group">
                                        <label for="path">Date</label>
                                        <input type="date" class="form-control" formControlName="date" id="date"
                                        [(ngModel)]="discussion_model.date" placeholder="Enter date">
                                    </fieldset>
                                    <fieldset *ngIf="!discussion_id" class="form-group">
                                        <label for="location">Location</label>
                                        <input type="text" (keydown.enter)="$event.preventDefault()" autocorrect="off"
                                            autocapitalize="off" spellcheck="off" class="form-control"
                                            formControlName="location" id="location" placeholder="Enter location"
                                            #search />
                                    </fieldset>
                                    <fieldset *ngIf="discussion_id" class="form-group">
                                        <label for="location">Location</label>
                                        <input type="text" (keydown.enter)="$event.preventDefault()" autocorrect="off"
                                            autocapitalize="off" spellcheck="off" class="form-control"
                                            [(ngModel)]="discussion_model.location" [ngModelOptions]="{standalone: true}"
                                            id="location" placeholder="Enter location" #search />

                                    </fieldset> -->
                                </form>
                            </div>
                            <div class="col-md">

                                <form [formGroup]="discussionForm">
                                    <!-- <fieldset class="mb-3">
                                        <label>Job For</label>
                                        <ng-select [items]="jobFor_list" bindLabel="name" bindValue="id" placeholder="Select Job For"
                                            [(ngModel)]="select_job" [ngModelOptions]="{ standalone: true }"
                                            [closeOnSelect]="false" (change)="getJobForId($event)">
                                        </ng-select>
                                    </fieldset>
                                    <fieldset class="form-group">
                                        <label for="title">Description</label>
                                        <textarea name="description" id="description" placeholder="Enter description"
                                            formControlName="description" class="form-control" cols="30"
                                            [(ngModel)]="discussion_model.description" rows="1"></textarea>
                                    </fieldset> -->
                                    <fieldset class="form-group">
                                        <label for="title">Notes</label>
                                        <textarea name="notes" id="notes" placeholder="Enter notes"
                                            formControlName="notes" class="form-control" cols="30" rows="1"
                                            [(ngModel)]="discussion_model.notes"></textarea>
                                    </fieldset>
                                    <!-- <fieldset class="form-group">
                                        <label for="title">Admin Notes</label>
                                        <textarea name="admin_notes" id="admin_notes" placeholder="Enter admin notes"
                                            formControlName="admin_notes" class="form-control" cols="30"
                                            [(ngModel)]="discussion_model.admin_notes" rows="1"></textarea>
                                    </fieldset> -->


                                </form>
                            </div>
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                                <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">
                                    Submit
                                </button>
                                <button type="reset" class="btn btn-secondary" (click)="back()">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>